import { Bottomsheet } from '@com/modal/containers/Bottomsheet';
import { useGetDoctorClinic } from '@api/in-person-booking/index.rq';
import { useGetDoctorProfile } from '@api/ocs/doctor/index.rq';
import useServiceBooking from '@hooks/useServiceBooking';

import DoctorOffice from './doctor-office';

type DoctorOfficesListBottomsheetProps = {
  doctorId: string;
  doctorName: string;
  profileId: number;
};

const DoctorOfficesListBottomsheet = ({
  doctorId,
  doctorName,
}: DoctorOfficesListBottomsheetProps) => {
  const { data: clinicData } = useGetDoctorClinic({ doctorId });

  const { data: doctorProfileResponse } = useGetDoctorProfile(Number(doctorId));

  const { handleOpenServiceCalendar } = useServiceBooking({
    doctorId: Number(doctorId),
    profileId: doctorProfileResponse?.result?.profileId,
    doctorProfile: doctorProfileResponse?.result,
  });

  return (
    <Bottomsheet
      height={'auto'}
      maxHeight={370}
      hasCloseButton
      title="دریافت نوبت حضوری"
    >
      <div className="max-h-[370px] flex flex-col gap-y-3 p-4 overflow-y-scroll">
        {clinicData?.data?.map((item) => (
          <DoctorOffice
            key={item?.id}
            officeName={item?.title}
            doctorName={doctorName}
            address={item?.clinicAddress}
            isActive={item?.isActive}
            onBookClick={() =>
              handleOpenServiceCalendar({
                clinic: item,
              })
            }
          />
        ))}
      </div>
    </Bottomsheet>
  );
};

export default DoctorOfficesListBottomsheet;
